<template>
  <div>
    <div style="padding-bottom: 84px">
      <div class="fixed-top py-4 py-md-3 bg-white shadow-sm">
        <div class="container text-center position-relative">
          <a href="javascript:" @click="$router.go(-1)" class="btn btn-outline-light position-absolute" style="left: 12px; top: -7px">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <div class="font-weight-bold">
            <div>WhatsApp</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="mx-auto" style="max-width: 400px">
        <div v-if="menu === 1">
          <form @submit.prevent="validate">
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold small">Número do WhatsApp *</label>
              <the-mask id="whatsapp" :mask="['(##) ####-####', '(##) #####-####']" class="form-control" type="tel" v-model="usuario.telefone" placeholder="(##) #####-####"
                        :disabled="load" required/>
            </div>
            <button class="btn btn-primary btn-block" :disabled="load || usuario.telefone.length < 10">
              <span v-show="load"><i class="fa fa-spinner fa-pulse"></i> aguarde</span>
              <span v-show="!load">Avançar</span>
            </button>
          </form>
        </div>

        <div v-if="menu === 2">
          <p>
            Enviamos uma mensagem com um PIN de 6 dígitos para o WhatsApp: <b>{{usuario.telefone | phone}}</b> <a href="javascript:" @click="clearMensagem(true)" v-if="!usuario.id_cliente">(alterar)</a>
          </p>
          <p class="small">
            Não recebeu a mensagem? <br>
            <span v-if="segundos <= 0"><a href="javascript:" @click="clearMensagem(false)">Enviar novamente</a></span>
            <span v-else>Você pode enviar novamente em <b>{{ segundos }}</b> segundos.</span>
          </p>
          <div class="alert alert-warning small">
            <i class="fa fa-info-circle mr-1"></i>
            Você receberá uma mensagem enviada pelo número do LeCard
          </div>
          <form @submit.prevent="verificarPin">
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold small">Digite o PIN enviado em seu WhatsApp</label>
              <the-mask id="validar_cod_pin" :mask="['#-#-#-#-#-#']" class="form-control" type="tel" placeholder="#-#-#-#-#-#" v-model="usuario.pin" required/>
            </div>
            <button class="btn btn-primary btn-block mb-3" :disabled="load">
              <span v-show="load"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
              <span v-show="!load">Avançar</span>
            </button>
          </form>
        </div>

        <div v-if="menu === 3">
          <p>
            Por favor informe seu nome completo para finalizarmos o seu cadastro.
          </p>
          <form @submit.prevent="logarWhatsapp">
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold small">Nome *</label>
              <input type="text" id="nomeZap" class="form-control" placeholder="Seu nome completo" v-model="nome_cliente" maxlength="100" required style="text-transform: capitalize">
            </div>
            <button class="btn btn-primary btn-block mb-3" :disabled="load || nome_cliente.length < 3">
              <span v-show="load"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
              <span v-show="!load">finalizar</span>
            </button>
          </form>
          <div class="my-4 text-muted">
            <div class="small">Concordo com os <a href="https://lecard.delivery/termos-de-uso/" target="_blank" class="text-primary font-weight-bold">Termos e Condições de uso!</a></div>
            <div class="small">Estou enviando informações verdadeiras podendo responder civilmente perante a lei.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {TheMask} from 'vue-the-mask';

  export default {
    name: 'PerfilWhatsapp',
    components: { TheMask },
    data() {
      return {
        load: false,
        menu: 1,
        edit: false,
        url: '',
        nome_cliente: '',
        segundos: 60,
        interval: null,
        usuario:  {
          id_cliente: null,
          telefone: '',
          pin: '',
          recaptcha: ''
        },
      }
    },

    methods: {
      enviarPinWhatsapp() {
        this.load = true;
        const dados = { telefone: this.usuario.telefone, id_cliente: this.usuario.id_cliente || null }

        if (this.$route.name === 'EsqueceuSenhaWhatsapp') {
          dados.validarcliente = true;
        }

        this.$http.post(this.$store.state.base_url + 'whatsapp/enviar-pin', dados)
          .then(res => {
            if (res && res.data.success) {
              this.countDown();
              this.menu = 2;
              this.$nextTick(() => {
                this.$helpers.focusrElement('validar_cod_pin');
              });

            } else {
              this.$swal("Não foi possível enviar o código de confirmação para este WhatsApp. Verifique os dados informados ou faça o login usando outro método.");
            }

            this.load = false;

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      logarWhatsapp() {
        if (this.menu === 3) {
          if (this.nome_cliente.trim().length < 3) {
            this.$swal('Informe um nome válido').then(() => {
              this.$helpers.focusrElement('nomeZap');
            });

            return;
          }

          this.usuario.nome_cliente = this.nome_cliente.trim();
        }

        if (this.$route.name === 'PerfilWhatsapp') {
          this.usuario.edit_cliente = localStorage.getItem('token');
        }

        this.load = true;
        this.$http.post(this.$store.state.base_url + 'login-whatsapp', this.usuario)
          .then(res => {
            const data = res.data || {};

            if (data.success && data.tipo === 1) {
              this.menu = 3;
              this.$nextTick(() => {
                this.$helpers.focusrElement('nomeZap');
              })

            } else if (data.success) {
              this.registerLogin(res);

            } else {
              this.$swal('Erro ao fazer login. Tente novamente ou altere o método de login');
            }

            this.load = false;

          }, res => {
            console.log(res);
            this.load = false;
            this.$swal((res.data || {}).msg || 'Erro temporário');
          });
      },

      verificarPin() {
        if (this.load) {
          return;
        }

        if (this.usuario.pin.length < 6) {
          this.$swal('Informe um PIN válido de 6 dígitos.').then(() => {
            this.$helpers.focusrElement('validar_cod_pin');
          });

          return;
        }

        this.logarWhatsapp();
      },

      validate() {
        if (this.usuario.telefone && this.usuario.telefone.length < 10 && this.usuario.telefone.length > 11) {
          this.$swal("Informe um número válido!");
          return;
        }

        this.load = true;
        this.enviarPinWhatsapp();
      },

      registerLogin(res) {
        const user = res.data.dados;
        this.$store.commit('setDataUser', res.data);
        sessionStorage.removeItem('cuponsReadonly');
        this.setOneSignal(user, res.data.token);

        if (user.sem_senha) {
          this.$router.push(this.url + '/perfil/meus-dados#senha');

        } else if (this.sacola && this.sacola.produtos.length) {
          this.$router.push(this.url + '/finalizar');

        } else {
          const msg = this.usuario.edit_cliente ? 'WhatsApp vinculado com sucesso!' : ((this.menu === '3' ? 'Cadastro ' : 'Login ') + ' realizado com sucesso');
          this.$swal(msg);
          this.$router.push(this.url + '/perfil');
        }

        this.setSentry({ email: user.email });
      },

      countDown() {
        clearInterval(this.interval);
        this.segundos = 60;
        this.interval = setInterval(() => {
          this.segundos = this.segundos - 1;

          if (this.segundos < 0) {
            clearInterval(this.interval);
          }
        }, 1000);
      },

      setOneSignal(user, token) {
        if (this.oneSignalIntegration) {
          this.$OneSignal.isPushNotificationsEnabled().then(isEnabled => {
            if (isEnabled) {
              this.$OneSignal.setExternalUserId(user.id_cliente).then(res => {
                this.$http.post(this.empresa.token + '/' + token + '/cliente/onesignal', { push_habilitado: '1' }).then(res => {});
              });
            }
          });
        }
      },

      clearMensagem(force) {
        if (force || this.segundos <= 0) {
          this.usuario.pin = '';
          this.menu = 1;

          this.$nextTick(() => {
            this.usuario.telefone = force ? '' : parseFloat(this.usuario.telefone);
            this.$helpers.focusrElement('whatsapp');

            if (!force) {
              this.validate();
            }
          });
        }
      }
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';

      if (localStorage.getItem('token') && this.$route.name !== 'PerfilWhatsapp') {
        this.$router.push(this.url + '/');
        return;
      }

      this.$helpers.focusrElement('whatsapp');
      const edit_whatsapp = sessionStorage.getItem('edit_whatsapp');
      const recuperar = this.$helpers.parseJSONObject(sessionStorage.getItem('recuperarSenha'));

      if (recuperar && recuperar.email) {
        sessionStorage.removeItem('recuperarSenha');
        this.usuario.id_cliente = recuperar.id_cliente || null;
        this.usuario.telefone = recuperar.email;
        this.validate();

      } else if (edit_whatsapp) {
        sessionStorage.removeItem('edit_whatsapp');
        this.usuario.telefone = edit_whatsapp;
        this.validate();

      } else if (this.$route.name === 'PerfilWhatsapp') {
        this.$router.push(this.url + '/perfil');
      }
    },

    computed: {
      unidades() {
        return this.$store.state.unidades;
      },

      sacola() {
        return this.$store.state.sacola;
      },

      empresa() {
        return this.$store.state.empresa;
      }
    },

    filters: {
      phone(phone) {
        if (phone) {
          if (phone.length === 10) {
            return phone.replace(/[^0-9]/g, '')
                .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

          } else if (phone.length === 11) {
            return phone.replace(/[^0-9]/g, '')
                .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
          }
        }

        return phone
      }
    }
  }
</script>
